<template>
  <b-card no-body class="app-ctrl">
    <b-card-body class="py-0 ttt" :class="[{ ttt2 : fixHeader }]">
      <!-- Control header line -->
      <h3 v-if="!fixHeader" class="margin-title border-bottom pb-0 mt-2 mb-0 text-center">{{ this.getTitle() }}</h3>

      <!-- Table Header line -->
      <div class="mb-0 wave-container" style="font-weight: bold">
        <div 
          v-for="(item, i) in headers" 
          :key="i"
          :class="[ 
            { 'half-year-wave': year >= 2025 }
          ]"
        >{{ item }}</div>
      </div>

      <div  v-for="(kpi, indexKpi) in items" 
            :key="indexKpi" 
            :class="[{ 'kpi-container': !fixHeader, 'kpi-container2': fixHeader }]">
        <template v-if="kpi.Code != 'Video Chat - Sophus3 2023 (monthly)'">
          <div>
            {{ $t("Webportal.CX.Margin.CategoryLabel")}} {{indexKpi + 1}} {{ kpi.Code }}
            <div :class="[{ 'wave-container': !fixHeader, 'wave-container2': fixHeader }]">
              <template  v-for="(wave, indexWave) in kpi.Waves">
                <span 
                    :class="[ 
                      { 'half-year-wave': year >= 2025 }
                    ]"
                    :style="(wave.Result != null ? 'cursor:pointer' : '')"
                    @click="preparePopup(kpi, wave.NameShort)"
                    v-if="wave.Year === year" 
                    :key="indexWave" >
                  <MarginKpiStatusIndicator :Accomplished="getWaveAccomplished(wave.NameShort, kpi.SurveyWave)"
                                            :HealingStatus="healingStatus"
                                            :InHealingPeriod="inHealingPeriod"
                                            :IsCurrentWave="wave.NameShort === currentWave"
                                            :IsHealingDeactivated="isHealingDeactivated"
                                            :ColorRange="colorRange"
                                            :AvailableHealings="availableHealings"
                                            :WaveResult="wave.Result" />
                </span>
              </template>
            </div>
          </div>
        </template>
      </div>

      <div class="mb-0" style="font-weight: bold">{{ year >= 2025 ?  $t('Webportal.CX.Margin.HalfYearResults') : $t('Webportal.CX.Margin.QuarterResults') }}</div>
      <div class="wave-container mb-0">
        <div  v-for="(wave, indexWave) in wavesOfSelectedYear" 
              :key="indexWave"
              :class="[
                { 'half-year-wave': year >= 2025 }
              ]"  >
          <MarginKpiStatusIndicator :Accomplished="getWaveResultAccomplished(wave)"
                                    :HealingStatus="healingStatus"
                                    :InHealingPeriod="inHealingPeriod"
                                    :IsCurrentWave="wave.NameShort === currentWave"
                                    :IsHealingDeactivated="isHealingDeactivated"
                                    :AvailableHealings="availableHealings"
                                    :ColorRange="colorRange"
                                    :WaveResult="wave.Result"
                                    :TooltipTitle="getResultToolTip(wave)" 
                                    :Threshold="threshold"/>
        </div>
      </div>
    </b-card-body>

    <b-card-footer v-if="!isHealingDeactivated" style="padding: 0rem !important;">
      <MarginHealingCard  class="margin-card-footer"
                          :clientLocationId="clientLocationId"
                          :currentWave="currentWave"
                          :kpiGroup="kpiGroup"
                          :brand="brand"
                          :currentWaveAccomplished = isCurrentWaveAccomplished() />
    </b-card-footer>
  </b-card>
</template>

<script>
import AppConfig from '@/mixins/AppConfig';
import DashboardService from "@/services/DashboardService";
import DateMixin from '@/mixins/DateMixin';
import MarginHealingCard from './MarginHealingCard.vue';
import MarginKpiStatusIndicator from './MarginKpiStatusIndicator.vue';
import { i18n } from "@/i18n";
import EventBus from "@/services/EventBus.js";

export default {
  mixins: [ AppConfig, DateMixin ],
  
  components: {
    MarginHealingCard,
    MarginKpiStatusIndicator
  },
  
  props: {
    brand:                { type: String, required: true },
    clientLocationId:     { type: Number, required: true },
    colorRange:           { type: Array, required: true },
    currentWave:          { type: String },
    fixHeader:            { type: Boolean, default: false },
    isHealingDeactivated: { type: Boolean, default: true },
    kpiGroup:             { type: Object, required: true },
    openPopup:            { type: Function },
    year:                 { type: Number, default: undefined }
  },

  data() {    
    return {
      healingStatus: "",
      inHealingPeriod: false,
      availableHealings: 0,
      headers: [ 'Q1', 'Q2', 'Q3', 'Q4' ],
      threshold: 1
    }
  },
  
  created() {    
    if (!this.isHealingDeactivated){
      DashboardService.getHealingStatus(this.clientLocationId, this.brand)
        .then((res) => {
          this.healingStatus = res.data.healingStatus;
          this.inHealingPeriod = res.data.inHealingPeriod;
          this.availableHealings = res.data.availableHealings;
        });
    }
  },

  mounted() {
    // Hmm kay, this is hacky ... but shows the correct values ...
    let self = this;
    setTimeout(function() { self.$forceUpdate() }, 1500);

    if(this.year === 2022) {
      this.threshold = 0.75;
    } 

    if(this.year >= 2025) {
      this.headers = [`${this.$t('Webportal.CX.Margin.HalfYear')} 1`, `${this.$t('Webportal.CX.Margin.HalfYear')} 2`]
    }

    EventBus.$on("LocalizationChanged", () => {
      if(this.year >= 2025) {
        this.headers = [`${this.$t('Webportal.CX.Margin.HalfYear')} 1`, `${this.$t('Webportal.CX.Margin.HalfYear')} 2`]
      } else {
        this.headers = [ 'Q1', 'Q2', 'Q3', 'Q4' ];
      }
    });
  },
  
  computed: {
    items() {
      if(this.year != 2022) {
        return this.kpiGroup.Items.filter(e => !e?.Name?.toLowerCase().includes("sophus"));
      }
      return this.kpiGroup.Items;
    },

    waves() {
      return this.kpiGroup.Waves;
    },

    wavesOfSelectedYear() {
      return this.kpiGroup.Waves.filter(wave => wave.Year === this.year);
    }
  },

  methods: {
    getTitle() {
      let result = this.kpiGroup.Name
        .replace('Margin', this.$t('Webportal.CX.Margin'))
        .replace(this.brand+' - ', '')
        .replace('Retail Marketing ', '')
        .replace('Digitale Händlerperformance ', '');
      return result;
    },

    getWaveIcon(NameShort, SurveyWave) {
      var res = null;
      for (let wave of SurveyWave) {
        if (wave.Name == NameShort) {
          res = wave.Accomplished ? "far fa-check" : "far fa-times";
          break;
        }
      }
      return res;
    },

    getWaveResult(NameShort, SurveyWave) {
      var res = null;
      for (let wave of SurveyWave) {
        if (wave.Name == NameShort) {
          res = wave.Result;
          break;
        }
      }
      return res;
    },

    shouldShowResults(waveName) {
      if(waveName !== this.currentWave) 
        return true;

      var quarter = this.currentWave.substring(0, 2);
      var today = new Date();
      var month = today.getMonth() + 1;
      var day = today.getDate();

      switch(quarter) {
        case "Q1":
          if(month == 3 && day > 15 || month == 4) 
            return true;

        case "Q2":
          if(month == 6 && day > 15 || month == 7) 
            return true;
        
        case "Q3":
          if(month == 9 && day > 15 || month == 10) 
            return true;

        case "Q4":
          if(month == 12 && day > 15 || month == 1) 
            return true;
        
        default:
          return false;
      }
    },

    getWaveResultAccomplished(wave) {
      // If Result not from selected year, do not show it
      if (wave.Year != this.year)        
        return null;

      // Show the current wave only two weeks before the quarter ends
      if (!this.shouldShowResults(wave.NameShort)) {         
        return null;
      }     

      return wave.Result != null 
        ? wave.Result >= this.threshold
        : null;
    },

    getWaveAccomplished(NameShort, SurveyWave) {
      // If Result not from selected year, do not show it
      let wave = SurveyWave.find(x => x.Name === NameShort);
      if (!wave || !wave.Name.includes(`${this.year}`))          
        return null;  
        
      var res = null;
      for (let wave of SurveyWave) {
        if (wave.Name == NameShort) {
          res = wave.Accomplished;
          break;
        }
      }
      return res;
    },

    getResultToolTip(wave) {
      var max = 0;
      this.kpiGroup.Items.forEach(item => {
        // skip monthly sophus results
        if(item.Name === 'Video Chat - Sophus3 2023 (monthly)') return;

        if(this.getWaveAccomplished(wave.NameShort, item.SurveyWave) != null){
          max++;
        }
      })
      
      var reached = max * wave.Result;

      if (wave.Result == null) {
        return this.$t('Webportal.CX.Margin.NoData');
      } else if (wave.Result < this.threshold) {
        return this.$t('Webportal.CX.Margin.FailedHalfYear', { PLACEHOLDER1: reached, PLACEHOLDER2: max});
      } else {
        return this.$t('Webportal.CX.Margin.Awesome', { PLACEHOLDER1: reached, PLACEHOLDER2: max});
      }
    },

    getColor(value) {
      if (!this.colorRange) return null;

      return this.colorRange.find(
        (thres) => thres.Minimum <= value && thres.Maximum >= value
      )?.Color;
    },

    isCurrentWaveAccomplished() {
      const currentWave = this.getCurrentWave();           
      if (!currentWave || currentWave.Result == null) { return null }

      return this.getCurrentWave().Result >= this.threshold;
    },

    getCurrentWave() {      
      return this.kpiGroup.Waves.find(w => w.NameShort == this.currentWave);
    },

    preparePopup(kpi, waveNameShort) {
      var preparedKpi = _.cloneDeep(kpi);
      if(kpi.Code === "Video Chat - Sophus3") {
        var sophusMonthly = this.kpiGroup.Items.find(kpi => kpi.Code === "Video Chat - Sophus3 2023 (monthly)");
        if(sophusMonthly) {
          preparedKpi.SophusMonthly = sophusMonthly;
          preparedKpi.SurveyWave = [...preparedKpi.SurveyWave, ...sophusMonthly.SurveyWave];
        }
      }
      this.openPopup(preparedKpi, waveNameShort);
    }
  },

  watch: {
    year(newVal, oldVal) {
      if(this.year >= 2025) {
        this.headers = [`${this.$t('Webportal.CX.Margin.HalfYear')} 1`, `${this.$t('Webportal.CX.Margin.HalfYear')} 2`]
      } else {
        this.headers = [ 'Q1', 'Q2', 'Q3', 'Q4' ];
      }
    },
  }
};
</script>

<style>

.ttt {
  top: 7.75rem;
  margin-bottom: 0.5rem;
}
.ttt2 {
  margin-bottom: 0.0rem!important;
}
.margin-card-footer {
  padding-top: 0.25rem!important;
  padding-bottom: 0.25rem!important;
  padding-left: 1.25rem!important;
  padding-right: 1.25rem!important;
  max-height: 8.5rem;
  min-height: 7.5rem;
}
.margin-title {
  font-size: 1rem;
  font-weight: bold;
}
.kpi-container {
  margin-bottom: -2px;
}
.kpi-container2 {
  margin-bottom: 2px;
  margin-top: 0px;
  line-height: 1.125em;
}
.wave-container {
  display: flex;
  justify-content: space-between;
  height: fit-content; 
}
.wave-container2 {
  display: flex;
  justify-content: space-between;
  height: 20px;
}
.circle {
  cursor: pointer;
  width: 20px;
  height: 20px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

  /* offset-x | offset-y | blur-radius | spread-radius | color */
  /* box-shadow: inset 0px 0px 5px 2px #00000066; */
}
.line-clamp-2 {
  text-overflow: ellipsis;
  overflow: hidden;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3 {
  text-overflow: ellipsis;
  overflow: hidden;

  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.lines-2 {
  min-height: 4.5rem;
}
.lines-3 {
  min-height: 9rem;
}
.sub-card-row {
  /* min-height: 48px; */
  /* display: flex; */
  justify-content: center;
  align-items: center;
}
.b-card {
  position: fixed !important;
}
.table-head {
  font-weight: bold;
  border-bottom: 1.5px solid #8080805c;
  text-align: center;
}
.table-row {
  border-bottom: 1px solid #8080805c;
  text-align: center;
}
.separator {
  border-right: 1px solid lightgrey;
}
.max-w {
  max-width: 50px;
}
.animated-yellow-shadow {
  animation: yellow-shadow 1s linear infinite alternate;
}
@keyframes yellow-shadow {
  /* offset-x | offset-y | blur-radius | spread-radius | color */
  0% {
    box-shadow: 0px 0px 7px 5px #ffeebe5b;
  }
  50% {
    box-shadow: 0px 0px 7px 5px #fff1b1ab;
  }
  100% {
    box-shadow: 0px 0px 7px 5px #ffeea2;
  }
  /* 0%  {box-shadow: 0px 0px 6px 4px #ffeebe5b, inset 0px 0px 5px 2px #33333366;}
  50%  {box-shadow: 0px 0px 6px 4px #fff1b1ab, inset 0px 0px 5px 2px #72727233;}
  100%  {box-shadow: 0px 0px 6px 4px #ffeea2, inset 0px 0px 5px 2px #ffffff8e;} */
}
.animated-red-shadow {
  animation: red-shadow 1s linear infinite alternate;
}
@keyframes red-shadow {
  /* offset-x | offset-y | blur-radius | spread-radius | color */
  0% {
    box-shadow: 0px 0px 7px 5px #ffbebe5b;
  }
  50% {
    box-shadow: 0px 0px 7px 5px #ffb1b1ab;
  }
  100% {
    box-shadow: 0px 0px 7px 5px #ffa2a2;
  }
}
.animated-green-shadow {
  animation: green-shadow 1s linear infinite alternate;
}
@keyframes green-shadow {
  /* offset-x | offset-y | blur-radius | spread-radius | color */
  0% {
    box-shadow: 0px 0px 7px 5px #cdffbe5b;
  }
  50% {
    box-shadow: 0px 0px 7px 5px #c7ffb1ab;
  }
  100% {
    box-shadow: 0px 0px 7px 5px #b8ffa2;
  }
}
.li-help {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.heal-icon {
}
.half-year-wave {
  width: 50%;
}
</style>